import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './Pages/Home';
import ErrorScreen from './Pages/ErrorScreen';


const RouteUrls = () => {
    return ( 
        <>
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Home />}/>
                <Route path='*' element={<ErrorScreen/>} />
            </Routes>
        </BrowserRouter>
        </>
     );
}
 
export default RouteUrls;